<template>
  <v-sheet class="bg-background flex-1-1 pa-4" justify="center">
    <v-container class="h-auto pa-4" fluid>
      <h1>{{ criteriaGroup.group_name }}</h1>
      <div v-html="criteriaGroup.description"></div>
      <v-row v-for="criteria of criteriaData?.data" justify="center" class="h-100">
        <v-col cols="12">
          <v-card>
            <v-card-title> {{ criteria.name }}</v-card-title>
            <v-card-subtitle>
              <div v-if="criteria.left() > 0">{{ criteria.left() }} Remaining</div>
              <div v-else class="w-100 text-wrap font-weight-bold text-red">
                This can no longer be picked.
              </div>
            </v-card-subtitle>
            <v-card-text>
              <v-row>
                <v-col cols="12" v-html="criteria.description"> </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6"
                  ><v-img :src="criteria.thubmnail?.url">
                    <template #sources>
                      <source :srcset="criteria.thubmnail?.webp_url" />
                    </template> </v-img
                ></v-col>
                <v-col cols="12" md="6">
                  <vue3-video-player
                    v-if="criteria.video"
                    :src="criteria.video.url"></vue3-video-player>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <FullWidthButton @click="emit('close')">Close</FullWidthButton>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>
<script setup lang="ts">
import { ICriteriaGroupDTO } from '@/dtos';
import { useCriteriaStore } from '@/stores';
import { computed } from 'vue';

const criteriaStore = useCriteriaStore();
interface Props {
  criteriaGroup: ICriteriaGroupDTO;
  branchYearId: string;
}
const props = defineProps<Props>();
const criteriaGroupId = computed(() => props.criteriaGroup.id);
const branchYearId = computed(() => props.branchYearId);
const emit = defineEmits(['close']);

const { data: criteriaData } = criteriaStore.getCriteriaForCriteriaGroupBranchYearQuery(
  branchYearId,
  criteriaGroupId,
);

const playerOptions = {
  controls: true,
  autoplay: false,
  preload: 'none', // 👈 prevents prefetching
  sources: [
    {
      src: 'https://example.com/video.mp4',
      type: 'video/mp4',
    },
  ],
};
</script>
